import React, { FunctionComponent, memo } from 'react';
import { Box } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import specificationDisclaimerStyles from './specificationDisclaimerStyles';

export interface ISpecificationDisclaimerProps {
  disclaimer: string;
}

const SpecificationDisclaimer: FunctionComponent<ISpecificationDisclaimerProps> = memo(({ disclaimer }) => {
  const styles = specificationDisclaimerStyles();

  return (
    <Tooltip
      placement={'top'}
      title={disclaimer}
      data-test={'specification:tooltip'}
      enterTouchDelay={0}
      leaveTouchDelay={5000}
      arrow={true}
      classes={{
        arrow: styles.tooltipArrow,
        tooltip: styles.tooltip,
      }}
    >
      <Box component={'span'} className={styles.asterisk}>
        {'*'}
      </Box>
    </Tooltip>
  );
});

export default SpecificationDisclaimer;
